import { emptyFragment } from '@execonline-inc/execonline-ui';
import { ActiveProgram, currentModule } from '../../../ProgramStore/Types';
import { AlreadyTranslated, T } from '../../../Translations';
import { ProgramCardPanel } from '../../Dashboard/ProgramCard';
import CourseProgressRing from '../../Dashboard/ProgramCard/CourseProgressRing';
import ModuleDueBadge from './ModuleDueBadge';

interface Props {
  activeProgram: ActiveProgram;
}

// Due dates only mean something for scheduled programs, and some organizations
// turn progress alerts off.
const showDueDate = (activeProgram: ActiveProgram): boolean =>
  activeProgram.programInstanceKind === 'scheduled' &&
  activeProgram.hideProgramProgressAlerts.map(() => false).getOrElseValue(true);

function ModuleProgressPanel({ activeProgram }: Props) {
  return (
    <ProgramCardPanel>
      <CourseProgressRing percentComplete={activeProgram.percentComplete} />
      {currentModule(activeProgram)
        .map((module) => (
          <div className="min-w-0" data-test-current-module={module.id}>
            <p className="m-0 text-lg font-semibold text-gray-900">
              <T kind="Module {{number}}" number={activeProgram.modules.indexOf(module) + 1} />
            </p>
            <p className="m-0 text-gray-600">
              <AlreadyTranslated content={module.title} />
            </p>
            <div className="mt-1 flex flex-wrap items-center gap-3 text-sm">
              <span className="text-gray-500">
                <T
                  kind="{{count}} segment left"
                  count={module.segments.filter((s) => s.status !== 'Complete').length}
                />
              </span>
              {showDueDate(activeProgram) && <ModuleDueBadge module={module} />}
            </div>
          </div>
        ))
        .getOrElse(emptyFragment)}
    </ProgramCardPanel>
  );
}

export default ModuleProgressPanel;
